import { useEffect, useRef, useMemo } from 'react'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBoxVertical/Types'
import { message } from 'antd'
import { YHModal } from '@/components/YHModal'
import { useLedgerModel } from '../ledgerModel'
import { globalPrompt } from '@/components/message'
import { ledgerService } from '../ledgerService'
import moment from 'moment'

export const EditLedgerModal = () => {
    const { editCarVisible, setEditCarVisible, loadData } = useLedgerModel()
    const formRef = useRef<IYhFormRef>()

    const canEdit = useMemo(() => {
        const departureTime = editCarVisible.value?.departureTime
        if (!departureTime) return false
        const depDate = new Date(departureTime)
        depDate.setHours(0, 0, 0, 0)
        const now = new Date()
        now.setHours(0, 0, 0, 0)
        const diffDays = Math.floor((now.getTime() - depDate.getTime()) / (1000 * 60 * 60 * 24))
        return diffDays === 1 || diffDays === 2
    }, [editCarVisible.value])

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            try {
                await ledgerService.tzUpdate({
                    id: editCarVisible.value?.id,
                    departureEndTime: moment(val.departureTime).format('YYYY-MM-DD HH:mm:ss'),
                })
                setEditCarVisible({
                    visible: false,
                    value: {},
                })
                message.success('修改成功！')
                loadData()
            } catch (error) {
                message.warning(error)
            }
        })
    }

    useEffect(() => {
        if (editCarVisible.value?.departureTime) {
            formRef.current?.setFieldsValue({
                ...editCarVisible.value,
                departureTime: moment(editCarVisible.value.departureTime),
            })
        }
    }, [editCarVisible.value])

    const onChange = (changedValues: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(changedValues)
    }

    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '日期',
                fieldName: 'departureTime',
                format: 'YYYY-MM-DD HH:mm:ss',
                showTime: true,
                span: 24,
                disabled: !canEdit,
            },
        ],
    }

    const FromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        onChange,
        boxs: [formItem],
    }

    const onClose = () => {
        globalPrompt('modal', {
            title: '修改台账',
            type: 'warning',
            text: '您正在修改的台账记录还没保存...是否关闭？',
            okText: '确认关闭',
            onOk: () =>
                setEditCarVisible({
                    visible: false,
                    value: {},
                }),
            cancelText: '继续修改',
        })
    }

    return (
        <YHModal
            visible={editCarVisible.visible}
            title="您正在修改台账..."
            cancelText="取消修改"
            okText="确定修改"
            onCancel={onClose}
            onOk={onOk}
            width={500}
            showFooter={canEdit}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
